const aBetterWorld = () => {
    
}

module.exports = aBetterWorld;